<template>
  <LoginWrapper>
    <template v-slot:main>
      <h2 class="login-title">Sign in to your account</h2>
      <div class="text-left">
        <NotificationBar v-if="resultSuccessMessage" type="success">
          <NotificationBarTitle>{{resultSuccessTitle}}</NotificationBarTitle>
          {{resultSuccessMessage}}
        </NotificationBar>
      </div>
      <FormGroup v-bind:form="loginForm">
        <div v-show="!displayTokenEntry">
          <div class="row input-row mt-4 mb-2">
            <div class="col-12">
              <FormInputText
                placeholder="Email"
                v-model="email"
                field="email"
                class="login-input"
                icon="fa-envelope"
              />
            </div>
          </div>
          <div class="row input-row my-2">
            <div class="col-12">
              <FormInputText
                type="password"
                placeholder="Password"
                v-model="password"
                field="password"
                icon="fa-lock"
                class="login-input"
              />
            </div>
          </div>
        </div>
        <div v-show="displayTokenEntry">
          <div class="row input-row mt-4 mb-2">
            <div class="col-12">
              Enter your 6-digit authenticator code<br />
              <FormInputText
                ref="tokenInput"
                placeholder="Code"
                v-model="token"
                field="token"
                class="login-input"
                icon="fa-key"
              />
            </div>
          </div>
        </div>
        <div class="row input-row my-4">
          <div class="col-12">
            <FormButton
              type="submit"
              :loading="submitting" 
              @click="onLoginSubmit"
              class="btn-lg block full-width login-submit">SIGN IN</FormButton>
          </div>
        </div>
        <div class="row mb-4" v-if="displayTokenEntry">
          <div class="col-6 text-left">
            <a href="#" @click.prevent="resetForm">Back</a>
          </div>
        </div>
        <div class="row" v-if="false">
          <div class="col-6 text-left">
            <router-link to="/account/forgotpassword" class="login-small-links">Forgot your password?</router-link>
          </div>
        </div>
      </FormGroup>
    </template>
    <template v-slot:sidebar>
      <div class="login-side-title">Welcome</div>
      <!--
        Don&apos;t have an account?<br />
        <div class="mt-2">
          <router-link to="/account/registration" class="login-sidebar-button">Sign up</router-link>
        </div>
      -->
    </template>
  </LoginWrapper>
</template>

<script>
import form from '@/mixins/form'
import LoginWrapper from '@/modules/core/components/loginWrapper'

export default {
  name: 'Login',
  mixins: [form],
  components: {
    LoginWrapper
  },
  data: () => {
    return {
      email: "",
      password: "",
      token: '',
      displayTokenEntry: false,
      resultSuccessTitle: '',
      resultSuccessMessage: '',
      submitting: false,
      loginForm: {}
    };
  },
  mounted() {
    // If coming from an account registration / forgot password, display the message
    if(this.$route.params.successMessage && this.$route.params.successMessage != '') {
      this.$data.resultSuccessTitle = this.$route.params.successTitle || 'Success'
      this.$data.resultSuccessMessage = this.$route.params.successMessage
    }
  },
  methods: {
    onLoginSubmit(event) {
      if (event) event.preventDefault()

      this.$data.loginForm = this.clearFormResponse()
      this.$data.resultSuccessTitle = ''
      this.$data.resultSuccessMessage = ''

      this.submitting = true

      this.$api.post("/users/authenticate", {
          email: this.email,
          password: this.password,
          token: this.token
        })
        .then(response => {
          // Check if requesting MFA token
          if(response.data.requireMFAToken) {
            this.token = ''
            this.displayTokenEntry = true

            this.$nextTick(() => {
              this.$refs.tokenInput.select()
            })
            return
          }

          this.$authService.setAuthToken(response.data.token, true);
          this.$socketService.disconnect()
          this.$socketService.connect()
          if(this.$route.query.redirect)
            this.$router.replace(this.$route.query.redirect)
          else
            this.$router.push("/")
        })
        .catch(err => {
          // Process errors
          this.$data.loginForm = this.processFormResponse(err);

        })
        .finally(() => {
          this.submitting = false
        })
    },
    resetForm() {
      this.email = ''
      this.password = ''
      this.token = ''
      this.displayTokenEntry = false
    }
  }
}
</script>
